// eslint-disable
import { AfterViewInit, Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import interact from 'interactjs';
import { environment } from '../../../../../../../environments/environment';
import { QuickLink, QuickLinkType } from '../../../../../../models/quick-link';
import { QuickLinkSignFormData } from '../../../../../../models/quick-link-sign-form-data';
import { ApplicationStateService } from '../../../../../../services/application-state.service';
import { AssetService } from '../../../../../../services/asset.service';
import { HomeworkService } from '../../../../../../services/homework.service';
import { QuickLinkService } from '../../../../../../services/quick-link.service';
import { QuickLinkUtils } from '../../../../../../utils/quick-link-utils';
import { TooltipUtils } from '../../../../../../utils/tooltip-utils';
import { ModalComponent } from '../../../../../../models/modal-component';
import { ModalService } from '../../../../../../services/modal.service';
import { NgClass } from '@angular/common';
import { SignFormComponent } from '../sign-form/sign-form.component';
import { AssetPipe } from '../../../../../../pipes/asset.pipe';
import { AmComponent, Configuration } from '@lemberger/lemberger-am';

@Component({
    selector: 'page-quick-link-modal',
    templateUrl: './quick-link-modal.component.html',
    styleUrls: ['./quick-link-modal.component.scss'],
    imports: [
        NgClass,
        SignFormComponent,
        AssetPipe,
        AmComponent
    ],
    standalone: true
})
export class QuickLinkModalComponent extends ModalComponent implements OnInit, AfterViewInit, OnDestroy {

    @Input() declare modalable: QuickLink;
    opendOnPage = false;
    iFrameId: string;
    isSignable: boolean;
    specialQuickLinkImageURL: string;
    formData: QuickLinkSignFormData;
    newHSMActive: boolean;
    loading: boolean;
    dirty: boolean;
    err: string;
    thiz = this;
    hsmConfig: Configuration;

    constructor(
        public sanitizer: DomSanitizer,
        public modalService: ModalService,
        public assetService: AssetService,
        public applicationStateService: ApplicationStateService,
        public quickLinkService: QuickLinkService,
        private homeworkService: HomeworkService) {
        super();
    }

    private _iFrameURL: SafeResourceUrl;

    get iFrameURL(): SafeResourceUrl {
        return this._iFrameURL;
    }

    set iFrameURL(value: string | SafeResourceUrl) {
        if (typeof value === 'string') {
            this._iFrameURL = this.sanitizer.bypassSecurityTrustResourceUrl(value);
        } else {
            this._iFrameURL = value;
        }
    }

    dirtFunc = $event => {
        this.dirty = true;
    };

    @HostListener('window:message', ['$event']) onPostMessage(event): void {
        // In some cases the h5p-resizer.js is overwriting our message ("hello" from the origin package - h5presizer.js)
        if ((typeof event.data === 'object' || (event.data instanceof Object)) && (event.data.action === 'hello')) {
            // eslint-disable-next-line max-len
            const iFrame = (document.getElementById(this.iFrameId) as HTMLIFrameElement).contentWindow.document.getElementsByTagName('iframe')[0];
            const height = (iFrame as HTMLIFrameElement).contentWindow.document.body.offsetHeight;

            iFrame.style.width = '100%';
            iFrame.style.height = `${height + 25}px`;
        }

        // Resize outer iFrame
        if ((typeof event.data === 'object' || (event.data instanceof Object)) && (event.data.action === 'resize')) {
            const message: { context: string; originHeight: number; scrollHeight: number; action: string } = event.data;
            // eslint-disable-next-line max-len
            const iFrame = (document.getElementById(this.iFrameId) as HTMLIFrameElement).contentWindow.document.getElementsByTagName('iframe')[0];
            iFrame.style.width = '100%';
            const newHeight = `${message.originHeight + 25}px`;

            iFrame.style.height = newHeight;
            window.top.postMessage({ iframe: this.iFrameId, height: newHeight }, '*');
        }
    }

    ngOnInit(): void {
        this.iFrameId = `bookviewerHSMiFrame_${Math.floor((Math.random() * 10000) + 1)}`;

        this.loading = true;
        this.newHSMActive = environment.features.newHsmActivated && this.applicationStateService.bookConfig.hsmActive;

        this.hsmConfig = {
            quickLink: QuickLinkUtils.getLinkCode(this.modalable.link),
            mode: this.modalable.isSolutionLink ? 'editor' : undefined,
            user: this.applicationStateService.userData as any,
            bookConfig: this.applicationStateService.bookConfig as any,
            contextId: this.applicationStateService.bookId,
            embedded: true
        };

        this.isSignable = this.quickLinkService.isSignableQuicklink(this.modalable);

        if (this.isSignable) {
            this.loading = false;
            this.initSpecialQuickLinkImage();
            // this.refreshForm();

        } else {
            this.initQuickLinkModal();
        }

        window.document.addEventListener('contentChanged', this.dirtFunc, false);

    }

    ngAfterViewInit(): void {

        if (this.isSignable || this.modalable.isSignable) {
            this.refreshForm();
        } else {
            $(`#quickLink-${this.modalable.id}`)
                .on('shown.bs.modal', () => {
                    const backdrop = $('.modal-backdrop');

                    if (backdrop.length) {
                        backdrop.addClass('modal-backdrop-show');
                    }
                });
        }

    }

    ngOnDestroy(): void {
        $(`#quickLink-${this.modalable.id}`)
            .off('shown.bs.modal');

        window.document.removeEventListener('contentChanged', this.dirtFunc);
        this.modalService.closeModal(this.modalable.getModalId());
    }

    getModalId(): string {
        return 'quicklinkModal';
    }

    getIFrameURL(): SafeResourceUrl {
        if (!this.iFrameURL) {
            let link;

            if (environment.features.newHsmActivated && this.applicationStateService.bookConfig.hsmActive) {
                link = this.homeworkService.getHsmLink(this.modalable.link);
                if (this.modalable.isSolutionLink) {
                    link += '?mode=editor';
                }
            } else {
                link = this.modalable.combinedLink;
                if (this.modalable.isSolutionLink) {
                    link += '.json&mode=editor';
                }
            }

            const h5pSource = new URLSearchParams(window.location.search).get('h5pSource');
            if (h5pSource) {
                const url = new URL(link);
                url.searchParams.set('h5pSource', h5pSource);
                link = url.toString();
            }

            this.iFrameURL = link;
        }

        return this.iFrameURL;
    }

    close(): void {
        $('html')
            .css('cursor', 'initial');
    }

    initInteract(): void {

        if (this.err) {
            return;
        }

        interact('.quicklink-modal')
            .draggable({
                allowFrom: '.drag-handler',
                onstart: this.startOverlay,
                onmove: this.dragEvent,
                onend: this.endOverlay
            })
            .resizable({
                edges: {
                    left: true,
                    right: '.resize-handler',
                    top: true,
                    bottom: '.resize-handler'
                },
                onstart: this.startOverlay,
                onmove: this.resizeEvent,
                onend: this.endOverlay
            })
            .ignoreFrom([
                '.quicklink-modal .modal-content .close-button',
                '.quicklink-modal .modal-content .to-page.minimize',
                '.quicklink-modal .modal-content .modal-toolbar'
            ].join(', '));
    }

    openOnPage(): void {

        let containerName;

        if (this.applicationStateService.isScrollMode()) {
            return;
        } else {
            containerName = '.bookviewer-single-page-container';
        }

        const container = $(containerName)
            .first();
        const id = `#${this.getModalId()} .modal-content`;
        const ele = $(id)
            .first();
        ele.width(container.width());
        ele.height(container.height());
        ele.css('top', container.position().top);
        ele.css('left', container.position().left);
        this.opendOnPage = true;
    }

    startOverlay(event): void {
        const target = $('.iframe-overlay');
        target.css('display', 'block');
    }

    endOverlay(event): void {
        const target = $('.iframe-overlay');
        target.css('display', 'none');
    }

    isMaximized(): boolean {
        const target = $(`[id=${this.getModalId()}]`);
        const maxWidth = target.data('width');
        const maxHeight = target.data('height');

        if (!maxWidth || !maxHeight) {
            return true;
        }

        const width = target.width();
        const height = target.height();

        if (width !== maxWidth) {
            return false;
        }

        return height === maxHeight;
    }

    /**
     * change modal size (and position) to initial / max size (and position)
     */
    maximize(): void {
        if (this.err) {
            return;
        }

        // update the element's style
        const target = $(`[id=${this.getModalId()}]`);
        const width = target.data('width');
        const height = target.data('height');

        target.width(`${width}px`);
        target.height(`${height - 130}px`);

        target.css('-webkit-transform', 'translate(0px,0px)');
        target.css('transform', 'translate(0px,0px)');

        target.data('x', 0);
        target.data('y', 0);
    }

    reloadIFrame(): void {
        this.iFrameURL = undefined;
        setTimeout(() => {
            this.iFrameURL = this.getIFrameURL();
        }, 100);
    }

    getId(): string {
        return this.modalable.getModalId();
    }

    /**
     * From http://interactjs.io/#resizing
     * @param event
     */
    private resizeEvent(event): void {
        const target = event.target;
        let x = (parseFloat(target.getAttribute('data-x')) || 0);
        let y = (parseFloat(target.getAttribute('data-y')) || 0);

        const width = event.rect.width;
        const height = event.rect.height;

        // update the element's style
        target.style.width = `${width}px`;
        target.style.height = `${height}px`;

        if (!target.getAttribute('data-width') && !target.getAttribute('data-height')) {
            target.setAttribute('data-width', width);
            target.setAttribute('data-height', height);
        }

        // translate when resizing from top or left edges
        x += event.deltaRect.left;
        y += event.deltaRect.top;

        target.style.webkitTransform = target.style.transform =
            `translate(${x}px,${y}px)`;

        target.setAttribute('data-x', x);
        target.setAttribute('data-y', y);
    }

    /**
     * From http://interactjs.io/#resizing
     * @param event
     */
    private dragEvent(event): void {

        if (this.err) {
            return;
        }

        const target = event.target;
        // keep the dragged position in the data-x/data-y attributes
        const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
        const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

        // translate the element
        target.style.transform = `translate(${x}px, ${y}px)`;
        target.style.webkitTransform = target.style.transform;

        // update the posiion attributes
        target.setAttribute('data-x', x);
        target.setAttribute('data-y', y);
    }

    private refreshForm(): void {
        this.quickLinkService.getSignedQuickLinkInformation(this.modalable)
            .then(result => {
                this.formData = result as QuickLinkSignFormData;
            }).catch(err => {
            if (!this.applicationStateService.userData.loggedIn && (err.status === 401 || err.status === 403)) {
                this.err = 'Für diese Aktion wird ein Benutzerkonto benötigt.';
            } else if (err.status === 403) {
                this.err = 'Der Quicklink ist nur mit Stickercode verfügbar.';
            } else {
                this.err = 'Der Quicklink ist leider nicht verfügbar.';
            }
            // this.isSignable = false;
            // this.initQuickLinkModal();
        });
    }

    private initSpecialQuickLinkImage(): void {
        const code = QuickLinkUtils.getLinkCode((this.modalable as any).link);

        let quickLinkType = QuickLinkUtils.getMatchingQuickLinkType(code, this.applicationStateService.bookConfig.quickLinkPrefix);
        if (quickLinkType === QuickLinkType.OTHER && this.modalable.type !== quickLinkType) {
            quickLinkType = this.modalable.type;
        }

        switch (quickLinkType) {
            case QuickLinkType.E_SQUIRREL:
                this.specialQuickLinkImageURL = this.assetService.getUrl('sidebar-quicklinks/eSquirrel_logo_claim_transparent.png');
                break;
            case QuickLinkType.PHASE:
                this.specialQuickLinkImageURL = this.assetService.getUrl('sidebar-quicklinks/phase-6-logo.svg');
                break;
            case QuickLinkType.GMT:
                this.specialQuickLinkImageURL = this.assetService.getUrl('sidebar-quicklinks/gmt-logo.png');
                break;
            case QuickLinkType.MATHION:
                this.specialQuickLinkImageURL = this.assetService.getUrl('sidebar-quicklinks/mathion-logo.png');
                break;
            case QuickLinkType.MATHE_GYM:
                this.specialQuickLinkImageURL = this.assetService.getUrl('sidebar-quicklinks/matheGym-logo.png');
                break;
            case QuickLinkType.MATHE4ALLE:
                this.specialQuickLinkImageURL = this.assetService.getUrl('sidebar-quicklinks/mathe4Alle-logo.png');
                break;
            case QuickLinkType.DIGBI:
                this.specialQuickLinkImageURL = this.assetService.getUrl('sidebar-quicklinks/digbi-logo.png');
                break;
            case QuickLinkType.OTHER:
                if (this.applicationStateService.bookConfig.bookSource === 'sia') {
                    this.specialQuickLinkImageURL = this.assetService.getUrl('sidebar-quicklinks/sia-logo.png');
                } else {
                    this.specialQuickLinkImageURL = undefined;
                }
                break;
            default:
                this.specialQuickLinkImageURL = undefined;
        }

        // Yedo has no unique slug within the quick link. Type is set out of the redirect.
        if (this.modalable.isYedo()) {
            this.specialQuickLinkImageURL = this.assetService.getUrl('sidebar-quicklinks/yedo-logo.png');
        }
        if (this.modalable.isCalcuflow()) {
            this.specialQuickLinkImageURL = this.assetService.getUrl('sidebar/sidebar-icon-calcuflow.png');
        }
    }

    /**
     * Performs some QuickLink init routine.
     */
    private initQuickLinkModal(): void {
        this.loading = true;
        this.getIFrameURL();
        if (this.modalable.modalData.tested) {
            this.err = this.modalable.modalData.err;
            this.loading = false;
            if (this.modalable.modalData.err) {
                this.initInteract();
            }

            return;
        }

        if (this.modalable.isGMT()) {
            this.loading = false;
            this.err = 'Der Mathe-Trainer ist seit 01.09.2024 nicht mehr Teil unseres Gratis-Mathematik-Angebotes.';

            return;
        }

        this.quickLinkService.testQuickLinks([this.modalable]).then(result => {
            this.err = undefined;
            if (result[0].found) {
                this.loading = false;

                if (this.modalable.isSolutionLink && !result[0].showSolution) {
                    this.err = 'Für diese Aufgabe ist leider keine Lösung vorhanden.';

                    return;
                }

                this.initInteract();
                ($('[data-bs-toggle="tooltip"]') as any).tooltip(TooltipUtils.defaultTooltipConfig);

            } else {
                this.loading = false;
                this.err = 'Der Quicklink ist leider nicht verfügbar.';
            }
        });
    }
}
